"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedgiftbag = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 48 56",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedgiftbag` : '') + (description ? ` desc-brandedgiftbag` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedgiftbag"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedgiftbag"
  }, description), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_24038_8640",
    style: {
      "maskType": "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "11",
    width: "48",
    height: "45"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.76 13.57a2 2 0 0 1 1.98-1.71h30.64a2 2 0 0 1 1.97 1.69l6.29 40.14A2 2 0 0 1 45.66 56H2.55A2 2 0 0 1 .6 53.53l.75-3.05 5.41-36.91Z",
    fill: "#F8985A"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_24038_8640)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.76 13.57a2 2 0 0 1 1.98-1.71h30.64a2 2 0 0 1 1.97 1.69l6.29 40.14A2 2 0 0 1 45.66 56H2.55A2 2 0 0 1 .6 53.53l.75-3.05 5.41-36.91Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m47.47 55.15.14-.26c.1-.23.12-.7.1-.78L42.4 20.1C30.5 31.36 18 39.24 1.88 46.7L.45 54.56c.08.6.76 1.38 2.02 1.45l22.21-.03 21.04.05c.15-.02.43-.06.72-.15.25-.09.47-.2.65-.36l.08-.05.24-.22.06-.09Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "14.5667",
    y: "15.6923",
    width: "19.4157",
    height: "2.87886",
    rx: "1.43943",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 11.2h12v4.3H18v-4.3Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 18.95h12V56H18V18.95Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m18 38.34 12-7.76V56H18V38.34Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.97 8.66a18.9 18.9 0 0 0-4.62-3.29c-1-.41-2.25-.11-2.8.68-.53.79-.15 1.77.86 2.18a24.17 24.17 0 0 0 7.3 1.2c-.2-.23-.45-.49-.74-.77Zm1.65 2.12-.01-.04.01.04Zm.97-1.49a.27.27 0 0 1 .06-.02l-.06.02Zm3.11 2.22c1.67-2.46-5.17-7.86-8.3-9.16-3.12-1.3-7.01-.36-8.68 2.1-1.68 2.46-.5 5.5 2.63 6.8 3.13 1.3 12.68 2.72 14.35.26Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.67 8.66a18.9 18.9 0 0 1 4.62-3.29c1-.41 2.26-.11 2.8.68.53.79.15 1.77-.85 2.18a24.17 24.17 0 0 1-7.31 1.2c.2-.23.46-.49.74-.77Zm-1.65 2.12.02-.04-.02.04Zm-.97-1.49a.27.27 0 0 0-.06-.02l.06.02Zm-3.1 2.22c-1.68-2.46 5.16-7.86 8.3-9.16 3.12-1.3 7-.36 8.68 2.1 1.67 2.46.5 5.5-2.64 6.8-3.12 1.3-12.68 2.72-14.35.26Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedgiftbag;